import React from 'react'

export default function index() {
    return (
        <div className="w-full bg-gray-900 rounded-2xl p-5">
            <div className="text-gray-500 mb-2">История матчей</div>
            <div className="flex text-sm text-gray-500 font-bold pb-5 px-2">
                <div className="w-full">Дата</div>
                <div className="w-full">Режим</div>
                <div className="w-full">Результат</div>
                <div className="w-full">Счет</div>
                <div className="w-full">Карта</div>
                <div className="w-full"></div>
            </div>
            <div className="whitespace-nowrap space-y-2 h-96 overflow-y-auto scrollbar pr-2 text-white">
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>
                <div className="flex items-center justify-center bg-mainBlack rounded-xl py-2 px-2">
                    <div className="w-full">11 may - 22:36</div>
                    <div className="w-full">5 vs 5</div>
                    <div className="w-full">WIN</div>
                    <div className="w-full">14/16</div>
                    <div className="w-full">de_mirage</div>
                    <div className="w-full flex justify-end">
                        <img className="" src="/static/images/design/map.png" alt="" />
                    </div>
                </div>

            </div>
        </div>
    )
}
